<template>
  <div class="flex flex-col justify-center">
    <section-header class="w-full mt-2" title="Image" @remove-section="imageUrl = null" />

    <div class="mt-5 relative">
      <base-input v-model="imageUrl"
                :color="focusColor"
                class="w-full text-gray-dark"
                placeholder="Paste link to Image"
                ref="imageUrlInput"
                variant="editor"
      />
      <vs-icon v-if="imageUrl.length"
               icon="clear"
               class="top-0 right-0 absolute py-2 pl-8 pr-1 m-1 cursor-pointer text-dark-gray bg-gradient-to-l via-white from-white hover:text-focus-error"
               @click="imageUrl = ''" />
    </div>
  </div>
</template>

<script>
import contentUtils from '@/utils/content.utils'
import SectionHeader from './SectionHeader'
import chatBubbleModule from '@/store/modules/chat-bubble.module'
import conversationModule from '@/store/modules/conversation.module'
import tailwind from '../../../../tailwind.config'

export default {
  components: { SectionHeader },

  computed: {
    actionId: chatBubbleModule.actionId,

    action() {
      return conversationModule.getAction(chatBubbleModule.bubbleSelected.stateId, this.actionId)
    },

    focusColor() {
      return tailwind.theme.colors.focus
    },

    imageUrl: {
      get() {
        return contentUtils.getImageUrl(this.action)
      },

      set(imageUrl) {
        const content = contentUtils.createContent(null, [], [], imageUrl)
        this._addAction(this.actionId, content)
      }
    }
  },

  methods: {
    _addAction(actionId, content) {
      conversationModule.addOutputAction(actionId, content)
    }
  },

  mounted() {
    this.$refs.imageUrlInput.focus()
  }
}
</script>
